/**
 * What a position-based student application chose, in a few words: the number
 * of positions, or the general pool when that is all it chose. Null when it
 * chose neither (an older application that ranked courses instead).
 *
 * @param {{ positions?: unknown[], generalPool?: boolean }|null|undefined} application
 * @returns {string|null}
 */
export function positionChoiceSummary(application) {
    const count = application?.positions?.length || 0;
    if (count > 0) return `${count} ${count === 1 ? 'position' : 'positions'}`;
    return application?.generalPool === true ? 'General pool only' : null;
}
